import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icons } from "../assets/icons/Icons";
import BackHeader from "../components/BackHeader";
export const Account = () => {
    const navigate = useNavigate();
    return (
        <div className="mx-2">
            <BackHeader title="Accounts" />

            <div className="pt-4">
                <img
                    src="./images/pictures/25s.jpg"
                    alt="img"
                    width="78"
                    className="mx-auto rounded-circle mt-n5 shadow-l"
                />
                <h1 className="color-theme text-center font-42 font-700 pt-1 mb-0">
                    Alexandra
                </h1>
                <p
                    className="text-center font-13 font-700"
                    style={{ color: "#C3C4FF" }}
                >
                    <i className="bi bi-check-circle-fill pe-2"></i>Verified
                    Account Holder
                </p>
            </div>
            <div className="mt-5">
                <div
                    className="mt-0 mb-2"
                    style={{ paddingLeft: "5px", paddingRight: "5px" }}
                >
                    <div className="list-group list-custom list-group-flush list-group-m rounded-xs">
                        <Link
                            to="/profile"
                            className="list-group-item"
                            style={{
                                paddingLeft: "11px",
                                paddingRight: "11px",
                                marginBottom: "10px",
                                background: "#141414",
                                borderRadius: "12px",
                            }}
                        >
                            <img
                                src="./images/store/accounts_information.png"
                                alt="information"
                                style={{ width: "42px" }}
                            />
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div className="mx-2">Information</div>
                                <Icons.SidebarRightArrow />
                            </div>
                        </Link>
                        <Link
                            to="/crypto-address"
                            className="list-group-item"
                            style={{
                                paddingLeft: "11px",
                                paddingRight: "11px",
                                marginBottom: "10px",
                                background: "#141414",
                                borderRadius: "12px",
                            }}
                        >
                            <img
                                src="./images/store/accounts_address.png"
                                alt="information"
                                style={{ width: "42px" }}
                            />
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div className="mx-2">My Crypto Address</div>
                                <Icons.SidebarRightArrow />
                            </div>
                        </Link>
                        <Link
                            to="/investment-dashboard"
                            className="list-group-item"
                            style={{
                                paddingLeft: "11px",
                                paddingRight: "11px",
                                marginBottom: "10px",
                                background: "#141414",
                                borderRadius: "12px",
                            }}
                        >
                            <img
                                src="./images/store/accounts_statics.png"
                                alt="information"
                                style={{ width: "42px" }}
                            />
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div className="mx-2">Investment Overview</div>
                                <Icons.SidebarRightArrow />
                            </div>
                        </Link>
                    </div>
                    <Link
                        to="/mapex"
                        className="form-custom form-icon"
                        style={{
                            background: "#2E2CB2",
                            width: "auto",
                            height: "63px",
                            borderRadius: "8px",
                            padding: "12px 20px",
                            color: "#16156B",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "40px",
                        }}
                    >
                        <p
                            className="font-600"
                            style={{
                                color: "#FFFFFF",
                                marginBottom: "0px",
                                fontSize: "16px",
                            }}
                        >
                            Contact Support
                        </p>
                    </Link>
                </div>
            </div>
        </div>
    );
};
